module.exports = __webpack_public_path__ + "media/images/snack-logo-black_old_old-d7a39e35277b9041e6646b1a0df606b3.svg";